
<div *ngIf="applicationAccessoire" class="MC-text-info-accessoire">
    <div class="MC-text-info-accessoire-div">
        <h5>
            {{'search.parts' | translate}}: {{infoAccessoire}}
        </h5>
    </div>
</div>

<div *ngIf="seeMultiTon" class="MC-text-info-accessoire">
    <div class="MC-text-info-accessoire-div">
        <h5>
            {{'search.combinaisons' | translate}}: {{infoMultiTon}}
        </h5>
    </div>
</div>

<form id="searchMixitCloud" [formGroup]="searchMixitCloudForm" [ngClass]="{'hidden' : seeMultiTon}">
    <div class="primarySearch">
        <div *ngIf="!applicationAccessoire && !seeMultiTon" class="divPrimarySearch">

            <div *ngIf="seeFiltreColorWebTech" class="div-selectedPaintLine">
                <mat-form-field>
                    <mat-label>{{'search.paintLine' | translate}}</mat-label>
                    <mat-select [(value)]="selectedPaintLine" (selectionChange)="launchColorwebtech($event)">
                        <mat-option *ngIf="!Utils.isAkzo(role)" value="ixell">IxellTech & Brillant direct</mat-option>
                        <mat-option *ngIf="!Utils.isAkzo(role)" value="oxelia">Oxelia & Brillant direct</mat-option>
                        <mat-option *ngIf="!Utils.isAxalta(role)" value="equinox">Equinox & Brillant direct</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <mat-form-field>
                <mat-label>{{'search.colorCode' | translate}}</mat-label>
                <input matInput type="text" formControlName="colorCode" (input)="searchColorCode()" list="listCode" autocomplete="off" />
                <datalist id="listCode">
                    <select>
                        <option *ngFor="let c of listCode" value="{{c}}"></option>
                    </select>
                </datalist>
            </mat-form-field>
        </div>

        <div *ngIf="!applicationAccessoire && !seeMultiTon" class="divSecondarySearch">

            <mat-form-field>
                <mat-label>{{'common.manufacturer' | translate}}</mat-label>
                <mat-select formControlName="manufacturer" (selectionChange)="SelectConstructeur()">
                    <mat-option *ngFor="let constructeur of searchCrit.listConstructeur" value="{{constructeur}}">{{constructeur}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="crossClearFilter">
                <i *ngIf="searchCrit.selectedConstructeur" matSuffix mat-icon-button class="fas fa-times" (click)="ClearConstructeurs($event)"></i>
            </div>
            <mat-divider vertical></mat-divider>

            <mat-form-field>
                <mat-label>{{'search.model' | translate}}</mat-label>
                <mat-select formControlName="model" (selectionChange)="SelectModele()">
                    <mat-option *ngFor="let modele of searchCrit.listModele" value="{{modele}}">{{modele}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="crossClearFilter">
                <i *ngIf="searchCrit.selectedModele" matSuffix mat-icon-button class="fas fa-times" (click)="ClearModele($event)"></i>
            </div>
            <mat-divider vertical></mat-divider>

            <mat-form-field>
                <mat-label>{{'search.year' | translate}}</mat-label>
                <mat-select formControlName="year" (selectionChange)="SelectAnnee()">
                    <mat-option *ngFor="let annee of searchCrit.listAnnee" value="{{annee}}">{{annee}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="crossClearFilter">
                <i *ngIf="searchCrit.selectedAnnee" matSuffix mat-icon-button class="fas fa-times" (click)="ClearAnnee($event)"></i>
            </div>
            <mat-divider vertical></mat-divider>

            <mat-form-field>
                <mat-label>{{'search.color' | translate}}</mat-label>
                <mat-select formControlName="colorGroup" (selectionChange)="SelectGroupeCouleur()">
                    <mat-option *ngFor="let color of searchCrit.listGroupeCouleur" value="{{color}}">{{color}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="crossClearFilter">
                <i *ngIf="searchCrit.selectedGroupeCouleur" matSuffix mat-icon-button class="fas fa-times" (click)="ClearGroupeCouleur($event)"></i>
            </div>
            <mat-divider vertical></mat-divider>

            <mat-form-field [hidden]="true">
                <mat-label>{{'search.application' | translate}}</mat-label>
                <mat-select formControlName="application" (selectionChange)="SelectApplication()">
                    <mat-option *ngFor="let application of searchCrit.listApplication" value="{{application}}">{{application}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="crossClearFilter">
                <i *ngIf="searchCrit.selectedApplication" matSuffix mat-icon-button class="fas fa-times" (click)="ClearApplication($event)"></i>
            </div>
            <mat-divider vertical [hidden]="true"></mat-divider>

            <div class="btnSearchMixitCloud">
                <button class="searchBtn" (click)="search()" [translate]="'search.searchBtn'"></button>
            </div>

        </div>

        <div *ngIf="applicationAccessoire" class="divApplicationAccessoireSearch">
            <mat-form-field>
                <mat-label>{{'search.application' | translate}}</mat-label>
                <!-- formControlName="applicationAccessoire" -->
                <mat-select [(value)]="selectedPart" (selectionChange)="SelectApplicationAccessoire($event)">
                    <mat-option value="tous">{{'shoppingcart.all' | translate}}</mat-option>
                    <mat-option *ngFor="let application of listApplicationAccessoire" value="{{application}}">{{application}}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="crossClearFilter">
                <i *ngIf="selectedApplicationAccessoire" matSuffix mat-icon-button class="fas fa-times" (click)="ClearApplicationAccessoire($event)"></i>
            </div>
        </div>

    </div>

    <div class="row error">
        <span class="col-sm-6 col-12 offset-sm-3" id="errorlbl" [translate]="'search.errorSearch'"></span>
    </div>

</form>

<!-- Liste des formules mères -->
<div *ngIf="!applicationAccessoire && !seeMultiTon" class="listFormulesMeres">
    <mat-grid-list cols="{{breakpoint}}" rowHeight="{{heightSize}}" [gutterSize]="'15px'">
        <div *ngFor="let teinte of teintesMeres">
            <mat-grid-tile class="model" *ngIf="teinte.codesCar">

                <div class="MC-tuileTeinteMeres">
                    <div class="MC-TTM-Teinte" data-colorId="{{teinte.marketColorId}}" (click)="SelectVariantesOrMulti(teinte, teinte.combinationOf.length > 0)">
                        <div class="MC-TTM-vignetteCouleur">
                            <img class="MC-TTM-imgCouleur" src="{{teinte.colorOnDisplayUri}}" alt="" />
                        </div>
                        <div class="MC-TTM-codeDesignation">
                            {{teinte.ixellCode}} ({{teinte.colorDescription}})
                        </div>
                    </div>
                    <mat-divider class="MC-TTM-divider"></mat-divider>
                    <div class="MC-TTM-info">
                        <div class="MC-TTM-divInfo">{{teinte.ownerName}}, {{teinte.codesCar.join(", ") }}</div>
                        <div class="MC-TTM-divInfo">{{teinte.colorUsedInYearsDescription}}</div>
                        <div class="MC-TTM-divInfo">{{teinte.originalTypeOfColor}}</div>
                    </div>
                    <div class="MC-TTM-action">
                        <!--<div *ngIf="false" class="MC-TTM-action-div" title="Enregistrer en tant que favoris">
                    <i *ngIf="teinte.isFavorite; else elseBlockIsFavorite" class="MC-TTM-action-icon MC-TTM-action-star fas fa-star"></i>
                    <ng-template #elseBlockIsFavorite>
                        <i class="MC-TTM-action-icon MC-TTM-action-star far fa-star"></i>
                    </ng-template>
                </div>-->
                        <div *ngIf="teinte.hasParts" class="MC-TTM-action-div" title="Ce résultats contient des accéssoires" (click)="SelectTeintesAccessoire(teinte)">
                            <i class="MC-TTM-action-icon MC-TTM-action-car-side far fa-car-side"></i>
                        </div>
                        <!--<div class="MC-TTM-action-div" title="Voir plus d'informations">
                    <i class="MC-TTM-action-icon MC-TTM-action-info fas fa-info"></i>
                </div>-->
                    </div>
                </div>
            </mat-grid-tile>
        </div>
    </mat-grid-list>

    <div *ngIf="searchCrit.lengthTotalSearch > 50 && searchCrit.lengthTotalSearch != searchCrit.positionInSearch" class="listFormulesMeres-showMore">
        <div class="listFormulesMeres-showMore-div">
            <button [disabled]="searchCrit.lengthTotalSearch == searchCrit.positionInSearch" class="listFormulesMeres-showMore-button" (click)="CompleteSearch()">{{'search.showMore'|translate}}</button>
        </div>
    </div>

</div>

<!-- Liste des formules accessoires -->
<div *ngIf="applicationAccessoire" class="listFormulesMeresAccessoire">

    <mat-grid-list cols="{{breakpoint}}" rowHeight="{{heightSize}}" [gutterSize]="'15px'">
        <div *ngFor="let teinte of teintesMeresAccessoire">
            <mat-grid-tile class="model" *ngIf="teinte.codesCar && (selectedPart == 'tous' || ( teinte.partNames && teinte.partNames.includes(selectedPart)) )">
                <div class="MC-tuileTeinteMeres">
                    <div class="MC-TTM-Teinte" data-colorId="{{teinte.marketColorId}}" (click)="SelectVariantesOrMulti(teinte)">
                        <div class="MC-TTM-vignetteCouleur">
                            <img class="MC-TTM-imgCouleur" src="{{teinte.colorOnDisplayUri}}" alt="" />
                        </div>
                        <div class="MC-TTM-partNames">
                            {{teinte.partNames.join(", ")}}
                        </div>
                        <div class="MC-TTM-codeDesignation">
                            {{teinte.codesCar[0]}} ({{teinte.colorDescription}})
                        </div>
                    </div>
                    <mat-divider class="MC-TTM-divider"></mat-divider>
                    <div class="MC-TTM-info">
                        <div class="MC-TTM-divInfo">{{teinte.ownerName}}, {{teinte.codesCar.join(", ") }}</div>
                        <div class="MC-TTM-divInfo">{{teinte.colorUsedInYearsDescription}}</div>
                        <div class="MC-TTM-divInfo">{{teinte.originalTypeOfColor}}</div>
                    </div>
                    <!--<div class="MC-TTM-action">-->
                    <!--<div *ngIf="false" class="MC-TTM-action-div" title="Enregistrer en tant que favoris">
                        <i *ngIf="teinte.isFavorite; else elseBlockIsFavorite" class="MC-TTM-action-icon MC-TTM-action-star fas fa-star"></i>
                        <ng-template #elseBlockIsFavorite>
                            <i class="MC-TTM-action-icon MC-TTM-action-star far fa-star"></i>
                        </ng-template>
                    </div>-->
                    <!--<div *ngIf="teinte.hasParts" class="MC-TTM-action-div" title="Ce résultats contient des accéssoires" (click)="SelectTeintesAccessoire(teinte)">
                        <i class="MC-TTM-action-icon MC-TTM-action-car-side far fa-car-side"></i>
                    </div>-->
                    <!--<div class="MC-TTM-action-div" title="Voir plus d'informations">
                        <i class="MC-TTM-action-icon MC-TTM-action-info fas fa-info"></i>
                    </div>-->
                    <!--</div>-->
                </div>
            </mat-grid-tile>
        </div>
    </mat-grid-list>

    <div *ngIf="searchCrit.lengthTotalSearchAccessoire > 50 && searchCrit.lengthTotalSearchAccessoire != searchCrit.positionInSearchAccessoire" class="listFormulesMeres-showMore">
        <div class="listFormulesMeres-showMore-div">
            <button [disabled]="searchCrit.lengthTotalSearchAccessoire == searchCrit.positionInSearchAccessoire" class="listFormulesMeres-showMore-button" (click)="CompleteSearchAccessoire()">{{'search.showMore'|translate}}</button>
        </div>
    </div>

</div>




<!-- Liste des formules multiton -->
<div *ngIf="seeMultiTon" class="listFormulesMeresMultiTon">

    <mat-grid-list cols="{{breakpoint}}" rowHeight="{{heightSize}}" [gutterSize]="'15px'">
        <div *ngFor="let teinte of teintesMeresMultiTon">
            <mat-grid-tile class="model"  *ngIf="teinte.codesCar">
                <div class="MC-tuileTeinteMeres">
                    <div class="MC-TTM-Teinte" data-colorId="{{teinte.marketColorId}}" (click)="SelectVariantesOrMulti(teinte)">
                        <div class="MC-TTM-vignetteCouleur">
                            <img class="MC-TTM-imgCouleur" src="{{teinte.colorOnDisplayUri}}" alt="" />
                        </div>
                        <div class="MC-TTM-codeDesignation">
                            {{teinte.codesCar[0]}} ({{teinte.colorDescription}})
                        </div>
                    </div>
                    <mat-divider class="MC-TTM-divider"></mat-divider>
                    <div class="MC-TTM-info">
                        <div class="MC-TTM-divInfo">{{teinte.ownerName}}, {{teinte.codesCar.join(", ") }}</div>
                        <div class="MC-TTM-divInfo">{{teinte.colorUsedInYearsDescription}}</div>
                        <div class="MC-TTM-divInfo">{{teinte.originalTypeOfColor}}</div>
                    </div>
                    <!--<div class="MC-TTM-action">-->
                    <!--<div *ngIf="false" class="MC-TTM-action-div" title="Enregistrer en tant que favoris">
                        <i *ngIf="teinte.isFavorite; else elseBlockIsFavorite" class="MC-TTM-action-icon MC-TTM-action-star fas fa-star"></i>
                        <ng-template #elseBlockIsFavorite>
                            <i class="MC-TTM-action-icon MC-TTM-action-star far fa-star"></i>
                        </ng-template>
                    </div>-->
                    <!--<div *ngIf="teinte.hasParts" class="MC-TTM-action-div" title="Ce résultats contient des accéssoires" (click)="SelectTeintesAccessoire(teinte)">
                        <i class="MC-TTM-action-icon MC-TTM-action-car-side far fa-car-side"></i>
                    </div>-->
                    <!--<div class="MC-TTM-action-div" title="Voir plus d'informations">
                        <i class="MC-TTM-action-icon MC-TTM-action-info fas fa-info"></i>
                    </div>-->
                    <!--</div>-->
                </div>
            </mat-grid-tile>
        </div>
    </mat-grid-list>

    <div *ngIf="searchCrit.lengthTotalSearchMultiTon > 50 && searchCrit.lengthTotalSearchMultiTon != searchCrit.positionInSearchMultiTon" class="listFormulesMeres-showMore">
        <div class="listFormulesMeres-showMore-div">
            <button [disabled]="searchCrit.lengthTotalSearchMultiTon == searchCrit.positionInSearchMultiTon" class="listFormulesMeres-showMore-button" (click)="CompleteSearchMultiTon()">{{'search.showMore'|translate}}</button>
        </div>
    </div>

</div>
